import React from 'react';
import './skills.css';
import Reveal from '../Reveal/Reveal';
import { skills } from '../../data/profile';

function Skills() {
  return (
    <section className="section section--alt" id="skills">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-eyebrow">Skills</span>
          <h2 className="section-title">Tools I work with</h2>
          <p className="section-sub">
            The stack I reach for when designing, deploying and operating data
            platforms end to end.
          </p>
        </Reveal>

        <div className="skills-grid">
          {skills.map(({ group, items }, index) => (
            <Reveal key={group} className="card skills-card" delay={index * 70}>
              <h3 className="skills-card-title">{group}</h3>
              <ul className="skills-chips">
                {items.map((item) => (
                  <li key={item} className="chip">
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
